// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uYGx","questions":"styles_questions__2_j2q","footer":"styles_footer__34KO5"};